import React from 'react';
import LayoutShell from '../../../layout/LayoutShell';

interface ArtifactPageWithChatLayoutProps {
  children: React.ReactNode;
  rightSidebar?: React.ReactNode;
}

export default function ArtifactPageWithChatLayout({
  children,
  rightSidebar,
}: ArtifactPageWithChatLayoutProps): React.ReactElement {
  return (
    <LayoutShell rightSidebar={rightSidebar ?? undefined} rightSidebarWidth={420}>
      {children}
    </LayoutShell>
  );
}
